export * from './member-api.service';
import { MemberApiService } from './member-api.service';
export const APIS = [MemberApiService];
